

























































import { defineComponent, PropType, ref, computed } from '@vue/composition-api';
import { Message } from '../../dataType';
import { useLocale } from '../../hooks/useLocale';
import http from 'common-module/src/util/http';
import { isOverseasVersion } from 'common-module/src/util';
import { ResultKeyListType, ResponseDataMap, TabListMapType } from '../message-card/search-assistant/type';
import ResultTable from './ResultTable.vue';
import { IconListMap } from '../message-card/search-assistant/const';
import { useInstance } from 'common-module/src/util/useInstance';
import { guideType } from '../message-card/search-assistant/type';
import { cloneDeep } from 'lodash';
export default defineComponent({
  components: {
    ResultTable
  },
  props: {
    message: {
      type: Object as PropType<Message<any>>,
      required: true
    }
  },
  setup(props) {
    const { t, tc } = useLocale();
    const activeTab = ref<ResultKeyListType>(
      props.message.content.targetActiveTab
    );
    const listMap = ref({
      issueResult: [],
      docResult: [],
      otherResult: [],
      guide: []
    });
    const isLoading = ref<boolean>(false);
    const tabList = ref([] as TabListMapType);
    const initTabList = () => {
      tabList.value = [
        { type: 'issueResult', name: t('app.name'), icon: IconListMap.issue, count: props.message.content.sourceIdMap.issueIds?.length || 0 },
        { type: 'docResult', name: t('navbar.document'), icon: IconListMap.doc, count: props.message.content.sourceIdMap.docIds?.length || 0 },
        { type: 'otherResult', name: t('epic.Attachments'), icon: IconListMap.attachment, count: props.message.content.sourceIdMap.attachmentRelIds?.length || 0 },
        { type: 'guide', name: t('navbar.manual'), icon: IconListMap.guide, count: props.message.content.sourceIdMap.guide?.length || 0 }
      ];
      tabList.value = tabList.value.filter((item) => item.count);
    };
    // 获取下一页数据
    const nextQuery = async () => {
      if (isLoading.value) {
        return;
      }
      try {
        isLoading.value = true;
        const params = cloneDeep(props.message.content.sourceIdMap);
        Reflect.deleteProperty(params, 'guide');
        const result:ResponseDataMap = await http.post('/chat/qa-assistant-source', params);

        initTabList();

        tabList.value.forEach((item) => {
          listMap.value[item.type] = result[item.type]?.data?.filter((i: any) => !!i);
        });

        listMap.value.guide = props.message.content.sourceIdMap.guide;
      } catch (e) {
        console.log(e);
        throw e;
      } finally {
        isLoading.value = false;
        if (activeTab.value === 'docResult') {
          const instance = useInstance();
          instance?.$track.send('WebIM_ClickAnswerSource', {
            Source_Number: props.message.content.sourceIdMap.attachmentRelIds?.length || 0,
            Source_Type: 'doc',
            File_types: []
          }, true);
        }

        if (activeTab.value === 'issueResult') {
          const instance = useInstance();
          instance?.$track.send('WebIM_ClickAnswerSource', {
            Source_Number: props.message.content.sourceIdMap.attachmentRelIds?.length || 0,
            Source_Type: 'issue',
            File_types: []
          }, true);
        }

        if (activeTab.value === 'otherResult') {
          const instance = useInstance();
          instance?.$track.send('WebIM_ClickAnswerSource', {
            Source_Number: props.message.content.sourceIdMap.attachmentRelIds?.length || 0,
            Source_Type: 'file',
            File_type: listMap.value.otherResult.map((item: any) => {
              return item?.linkUrl?.split('.')?.pop();
            })
          }, true);
        }
      }
    };
    const handleChangeTab = (v: {name: ResultKeyListType}) => {
      activeTab.value = v.name;
    };
    const showTab = computed(() => {
      return tabList.value.some(item => item.count) && isLoading.value === false;
    });
    const currentList = computed(() => {
      return listMap.value[activeTab.value] || [];
    });
    const currentTotal = computed(() => tabList.value.find((item) => item.type === activeTab.value)?.count || 0);
    nextQuery();
    return {
      t,
      tc,
      isLoading,
      overseas: isOverseasVersion,
      currentList,
      currentTotal,
      activeTab,
      handleChangeTab,
      tabList,
      showTab
    };
  }
});
